import { StyleSheet } from 'react-native';
import { textLatoStyleDS } from 'src/theme-v2/text';

export const style = StyleSheet.create({
  background: {
    width: '100%',
    height: '100%',
    borderRadius: 100,
    justifyContent: 'flex-start',
  },
  progress: {
    height: '100%',
    borderRadius: 100,
    justifyContent: 'center',
  },
  text: {
    textAlign: 'center',
    position: 'absolute',
    ...textLatoStyleDS.BodyBoldXs,
  },
  completed: {
    height: '100%',
    width: '100%',
    borderRadius: 100,
    justifyContent: 'center',
    alignItems: 'center',
  },
  textToShow: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  textOverlay: {
    ...textLatoStyleDS.BodyBoldXs,
  },
});
